/**
 * Build scoped financial KPI metrics shared by summary bar and KPI cards.
 * Total Revenue and Net Profit use portfolio-health only (no revenue-triad fallback).
 */

/**
 * @param {object} options
 * @param {object|null|undefined} options.profitabilityData — portfolio-health mapped payload
 * @returns {{ scopedRevenue: number|null, scopedCosts: number|null, scopedNetProfit: number|null }}
 */
export const buildScopedFinancialMetrics = ({
    profitabilityData = null,
} = {}) => {
    const scopedRevenue = Number.isFinite(Number(profitabilityData?.total_revenue))
        ? Number(profitabilityData.total_revenue)
        : null;

    const scopedCosts = Number.isFinite(Number(profitabilityData?.total_costs))
        ? Number(profitabilityData.total_costs)
        : null;

    const scopedNetProfit = (() => {
        const portfolioProfit = Number(profitabilityData?.net_profit);
        if (Number.isFinite(portfolioProfit)) {
            return portfolioProfit;
        }
        if (Number.isFinite(scopedRevenue) && Number.isFinite(scopedCosts)) {
            return scopedRevenue - scopedCosts;
        }
        return null;
    })();

    return { scopedRevenue, scopedCosts, scopedNetProfit };
};
